import { render, staticRenderFns } from "./SelectPopup.vue?vue&type=template&id=508ca5b4&"
import script from "./SelectPopup.vue?vue&type=script&lang=js&"
export * from "./SelectPopup.vue?vue&type=script&lang=js&"
import style0 from "./SelectPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports